import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataAppointmentModel} from '../../models/appointments/data-appointment.model';

@Component({
  selector: 'app-medical-information-appointment-dialog',
  templateUrl: './medical-information-appointment-dialog.component.html',
  styleUrls: ['./medical-information-appointment-dialog.component.scss']
})
export class MedicalInformationAppointmentDialogComponent implements OnInit {
  CaseWorkItemFormsId = null;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DataAppointmentModel,
              private dialogRef: MatDialogRef<MedicalInformationAppointmentDialogComponent>) {
    const formId = this.data.dataAppoitmentDetails.find(p => p.DetailParameterName === 'medicalInfo_CaseWorkItemFormsId');
    if (formId) {
      this.CaseWorkItemFormsId = formId.DetailParameterValue;
    }
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close();
  }
}
